import { useSelector } from "react-redux";

import Post from "./Post";

import { Container, Box } from "@mui/material";

const PostsList = ({ posts, followingsPosts, allOrFollowings }) => {
  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      {allOrFollowings === "all" &&
        posts.map((p, index) => <Post key={p._id} post={p} />)}
      {allOrFollowings === "followings" &&
        followingsPosts.map((p, index) => <Post key={p._id} post={p} />)}
    </Container>
  );
};

export default PostsList;
